import { AutoAwesome as AutoAwesomeIcon, Close as CloseIcon, Search as SearchIcon } from "@mui/icons-material";
import { Box, IconButton, InputAdornment, TextField } from "@mui/material";
import { ChangeEvent, FC, FormEvent, useRef, useState } from "react";

import "./index.css";

interface ITableSearchInputProps {
	aiSearch?: boolean;
	showClearButton?: boolean;
	placeholder?: string;
	onSubmit: (searchInput: string) => void;
}

const TableSearchInput: FC<ITableSearchInputProps> = (props) => {
	const { aiSearch, showClearButton, placeholder = "Search", onSubmit } = props;

	const inputRef = useRef<HTMLInputElement>(null);

	const [searchInput, setSearchInput] = useState<string>("");

	function handleChangeSearchInput(event: ChangeEvent<HTMLInputElement>) {
		setSearchInput(event.target.value);
	}

	function handleSubmitSearchInput(event: FormEvent) {
		event.preventDefault();
		onSubmit(searchInput);
	}

	function handleClearSearchInput() {
		setSearchInput("");
		onSubmit("");

		if (inputRef.current) inputRef.current.focus();
	}

	return (
		<Box component="form" noValidate onSubmit={handleSubmitSearchInput}>
			<TextField
				size="small"
				color="primary"
				variant="outlined"
				placeholder={placeholder}
				value={searchInput}
				onChange={handleChangeSearchInput}
				sx={{ minWidth: aiSearch ? "unset" : "320px" }}
				inputRef={inputRef}
				autoComplete="off"
				slotProps={{
					input: {
						classes: aiSearch ? { root: "ai-search-input" } : {},
						startAdornment: aiSearch ? (
							<InputAdornment position="start">
								<svg width={0} height={0}>
									<linearGradient id="linearColors" gradientTransform="rotate(45)">
										<stop offset={0.25} stopColor="#FC466B" />
										<stop offset={1} stopColor="#3F5EFB" />
									</linearGradient>
								</svg>

								<AutoAwesomeIcon fontSize="small" sx={{ fill: "url(#linearColors)" }} />
							</InputAdornment>
						) : (
							<InputAdornment position="start">
								<IconButton edge="start" size="small" type="submit">
									<SearchIcon />
								</IconButton>
							</InputAdornment>
						),
						endAdornment: aiSearch ? (
							<InputAdornment position="end">
								{showClearButton ? (
									<IconButton edge="end" size="small" onClick={handleClearSearchInput}>
										<CloseIcon fontSize="inherit" />
									</IconButton>
								) : null}

								<IconButton edge="end" type="submit">
									<SearchIcon fontSize="medium" />
								</IconButton>
							</InputAdornment>
						) : showClearButton ? (
							<InputAdornment position="end">
								<IconButton edge="end" size="small" onClick={handleClearSearchInput}>
									<CloseIcon />
								</IconButton>
							</InputAdornment>
						) : null
					}
				}}
			/>
		</Box>
	);
};

export default TableSearchInput;
